module.exports = __webpack_public_path__ + "img/ico_filters.7c5c83a0.svg";